import React from "react"
import Section from "components/Section"
import CardContainer from "components/CardContainer"
import Case from "components/Case"
import ResponsiveImage from "components/ResponsiveImage"
import { graphql } from "gatsby"

function CasePortfolio({ cases_list, ...props }) {
  const { lang } = props.pageContext
  const business_cases = cases_list.filter(
    (x) => x.case_item?.case_type === "Business"
  )
  const campaign_cases = cases_list.filter(
    (x) => x.case_item?.case_type === "Campaign"
  )

  function renderCaseSection(list) {
    return list.map((list_item) => {
      const { case_item } = list_item
      return (
        <Case
          key={case_item._meta.id}
          img={
            <ResponsiveImage
              img={case_item.case_imageSharp || case_item.case_image}
              alt={case_item.case_image.alt}
            />
          }
          title={case_item.title}
          summary={case_item.summary}
          url={case_item.case_url.url}
        />
      )
    })
  }

  return (
    <Section>
      <h2>{lang === "en-gb" ? "Companies" : "Virksomheder"}</h2>
      <CardContainer columns="1fr 1fr">
        {renderCaseSection(business_cases)}
      </CardContainer>
      <h2>{lang === "en-gb" ? "Campaign sites" : "Kampagnesites"}</h2>
      <CardContainer columns="1fr 1fr">
        {renderCaseSection(campaign_cases)}
      </CardContainer>
    </Section>
  )
}

export default CasePortfolio

export const query = graphql`
  fragment CaseFragment on PRISMIC_Case {
    case_type
    _meta {
      id
    }
    title
    summary
    case_image
    case_imageSharp @include(if: $isProduction) {
      childImageSharp {
        id
        main: fixed(width: 600, quality: 100) {
          ...GatsbyImageSharpFixed_withWebp
        }
        mobile: fixed(width: 400, quality: 100) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }
    case_url {
      ... on PRISMIC__ExternalLink {
        url
      }
    }
  }
`
